import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const RedirectToMain = () => {
    const navigate = useNavigate()
    useEffect(() => {
        const url = '/main'
        navigate(url, { replace: true })
    }, [])
    return null
}

export default RedirectToMain
